import React from 'react';
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { CheckCircle, Delete, Edit, MoreVert, Visibility } from '@mui/icons-material';

interface EstimateActionsProps {
  estimate: any;
  onEdit: () => void;
  onView: () => void;
  onDelete: () => void;
  onConvert: () => void;
  onStatusChange: (status: 'pending' | 'approved' | 'rejected') => void;
}

export function EstimateActions({
  estimate,
  onEdit,
  onView,
  onDelete,
  onConvert,
  onStatusChange,
}: EstimateActionsProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton aria-label="more" onClick={handleOpen}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => { handleClose(); onEdit(); }}>
          <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
          <ListItemText primary="Edit" />
        </MenuItem>
        <MenuItem onClick={() => { handleClose(); onView(); }}>
          <ListItemIcon><Visibility fontSize="small" /></ListItemIcon>
          <ListItemText primary="View" />
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => { handleClose(); onStatusChange('pending'); }}>
          <ListItemText primary="Mark Pending" />
        </MenuItem>
        <MenuItem onClick={() => { handleClose(); onStatusChange('approved'); }}>
          <ListItemText primary="Mark Approved" />
        </MenuItem>
        <MenuItem onClick={() => { handleClose(); onStatusChange('rejected'); }}>
          <ListItemText primary="Mark Rejected" />
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => { handleClose(); onConvert(); }} disabled={estimate.status === 'rejected'}>
          <ListItemIcon><CheckCircle fontSize="small" /></ListItemIcon>
          <ListItemText primary="Convert to Invoice" />
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => { handleClose(); onDelete(); }} sx={{ color: 'error.main' }}>
          <ListItemIcon><Delete fontSize="small" color="error" /></ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
      </Menu>
    </>
  );
}
